module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-ace.dc42de65.svg";